// extracted by mini-css-extract-plugin
export var cardContainer = "_nm-0";
export var cardHeader = "_nm-2";
export var collapsedState = "_nm-3";
export var dragHandle = "_nm-5";
export var dragHandleIcon = "_nm-6";
export var dragging = "_nm-1";
export var titleArea = "_nm-4";